
///member/ticket?ApiKey=8d2d93ea-21b1-423b-83b1-935e449ea964
function PurchaseTicketSvc($resource) {
  'ngInject';
  var odataUrl = TFL_Base_Url + 'member/ticket'
  return $resource(odataUrl, {}, {
      post: { method: 'POST', params: { APIKey: '@APIKey'}, isArray: true }
  });
};

export default {
  name: "PurchaseTicketSvc",
  fn: PurchaseTicketSvc
}